module.exports = "<a class=\"fullscreen-link\" (click)=\"maximizeIbox()\">\r\n    <i class=\"fa fa-{{expandToggle}}\"></i>\r\n</a>"